
import { defineComponent } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'

export default defineComponent(
{
    name: 'PayException',
    setup()
    {
        // Load router:
        const router = useRouter()
        // Use vuex:
        const store = useStore()
        // Get authentication status:
        const isAuthenticated = store.getters['auth/isAuthenticated']

        // Display error:
        store.commit('errors/setNuxeoErrors',
        {
            message: 'Payment error: There was an error when collecting payment'
        })
        router.push({ hash: '#error-summary-container' })
        // Return data:
        return {
            isAuthenticated
        }
    }
})
